class ExclusiveAddButton extends HTMLElement {
    constructor() {
      super();
      this.cartDrawer = document.querySelector("#CartDrawer");
    }
  
    connectedCallback() {
        this.exclusiveMain = document.querySelector("[js-exclusive-main]");
        this.addEventListener('click', this.renderExclusiveModel.bind(this));
    }
  
    renderExclusiveModel({ currentTarget }) {
      console.log(currentTarget);
      const handle = currentTarget.getAttribute('data-product-handle');
      const url = `/products/${handle}?section_id=exclusive-deal-popup`;
      currentTarget.classList.add("is-loading");
      this.ajaxSection(currentTarget, url)
    }

    ajaxSection(triggerBtn, url) {
        fetch(url)
        .then(response => response.text())
        .then(html => {
            const ajaxContainer = new DOMParser()
                .parseFromString(html, 'text/html')
                .querySelector(".shopify-section");

            if (ajaxContainer) {
                this.exclusiveMain.innerHTML = ajaxContainer.innerHTML;
                const upsells = triggerBtn.getAttribute('is');
                if(upsells){
                  const atc__btns = this.exclusiveMain.querySelector('add-to-cart');
                  atc__btns.setAttribute("is",upsells);
                  this.exclusiveMain.setAttribute("is",upsells);
                }
            }
        })
        .finally(() => {
            triggerBtn.classList.remove("is-loading");
        })
    }
}
  
customElements.define('exclusive-add-button', ExclusiveAddButton);

class ExclusiveDealPopup extends HTMLElement {
    constructor() {
      super();

    }
  
    connectedCallback() {
        this.init();
        this.initSlider();
        this.open();
    }

    init() {
        this.exclusiveMain = document.querySelector("[js-exclusive-main]");
        this.closeBtn = this.querySelector("[js-close-btn]");
        this.regularPrice = this.querySelector('[js-regular-price]');
        this.comparePrice = this.querySelector('[js-compare-price]');
        this.discountBadge = this.querySelector('[js-discount-badge]');
        this.addToCart = this.querySelector('add-to-cart');
        this.atcBtnLabel = this.querySelector('[js-atc-btn-label]');
        this.selectedLabel = this.querySelector('[js-selected-label]');

        this.sizeFields = this.querySelectorAll("[js-size-field]");
        this.productStitchers = this.querySelectorAll("[js-product-switcher]");

        this.closeBtn.addEventListener("click", this.close.bind(this));
      
        this.addEventListener("click", (event) => {
            event.stopPropagation();
            console.log(event);
            if(event.target.tagName !== 'EXCLUSIVE-DEAL-POPUP') return;
            this.close(event)
        });

        this.sizeFields.forEach( field => {
            field.addEventListener('change', ({ target }) => {
                this.updateOptionLabel(target);
                this.updatePrice(target);
                this.updateMasterId(target);
                this.updateAtcBtn(target);
            })
        });

        this.productStitchers?.forEach( productStitcher => {
            productStitcher.addEventListener('click', ({ currentTarget }) => {
                const handle = currentTarget.getAttribute('data-product-handle');

                this.renderSection(handle);
            })
        })
    }

    initSlider() {
        new Swiper("[js-exclusive-product-media-slider]", {
            loop: true,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
              dynamicBullets: true,
            },
            slidesPerView: 1,
            spaceBetween: 20,
        });
    }

    updatePrice(target) {
        const regularPriceWithMoney = target.getAttribute('data-regular-price');
        const comparePriceWithMoney = target.getAttribute('data-compare-price');

        const regularPrice = parseInt(regularPriceWithMoney.replace(/[^0-9]/g, ""), 10);
        const comparePrice = parseInt(comparePriceWithMoney?.replace(/[^0-9]/g, ""), 10);

        this.regularPrice.textContent = regularPriceWithMoney;
        this.comparePrice.textContent = comparePriceWithMoney || '';

        if(comparePrice) {
            const discountPercentage = Math.round((comparePrice - regularPrice * 100) / comparePrice);
            this.discountBadge.textContent = `${discountPercentage}% OFF`;
        }else {
            this.discountBadge.textContent = '';
        }
    }

    updateMasterId(target) {
        this.addToCart.setAttribute('data-variant-id', target.value)
    }

    updateAtcBtn(target) {
        const isAvailable = target.getAttribute('data-available') === 'true';
        if(isAvailable) {
            this.addToCart.classList.remove('is-disabled');
            this.atcBtnLabel.textContent = 'Add to cart'
        }else {
            this.addToCart.classList.add('is-disabled');
            this.atcBtnLabel.textContent = 'Sold out';
        }
    }

    updateOptionLabel(target) {
        this.selectedLabel.textContent = target.getAttribute('data-size-value');
    }

    open() {
        this.classList.add("is-open");
    }

    close(event) {
        event?.stopPropagation();

        this.classList.remove("is-open");
        this.innerHTML = "";
    }

    renderSection(handle) {
        const url = `/products/${handle}?section_id=exclusive-deal-popup`;

        this.exclusiveMain.querySelector('exclusive-deal-popup').classList.add('is-loading');
        this.ajaxSection(url);
    }
  
    ajaxSection(url) {
        fetch(url)
        .then(response => response.text())
        .then(html => {
            const ajaxContainer = new DOMParser()
                .parseFromString(html, 'text/html')
                .querySelector(".shopify-section");

            if (ajaxContainer) {
                ajaxContainer.querySelector("exclusive-deal-popup").classList.add("is-open");
                this.exclusiveMain.innerHTML = ajaxContainer.innerHTML;
                const upsells = this.exclusiveMain.getAttribute('is');
                if(upsells){
                  const atc__btns = this.exclusiveMain.querySelector('add-to-cart');
                  atc__btns.setAttribute("is",upsells);
                }
            }
        })
    }
  }
  
  customElements.define('exclusive-deal-popup', ExclusiveDealPopup);